import { render, staticRenderFns } from "./SoPopup.vue?vue&type=template&id=1a3cb0fc&"
import script from "./SoPopup.vue?vue&type=script&lang=js&"
export * from "./SoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports